<style lang="scss" src='./HoleList.scss' scoped></style>
<template src="./HoleList.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
  } from 'vuex';

  import { 
    saveHole,
    updateHole,
  } from '@/api/index';

  import MapBlueFlag from '@/assets/img/ic/ic_flag_blue.png';
  import MapRedFlag from '@/assets/img/ic/ic_flag_red.png';
  import MapStation from '@/assets/img/ic/ico_marker_station.png';
  import SecurityComponent from '@/components/SecurityComponent.vue';
  import SensorDetails from '@/views/sensors/details/SensorDetails.vue';
  let validSensors = [];


  export default {
    name: 'HoleList',
    extends: SecurityComponent,
    components: {
      SensorDetails,
    },
    data() {
      return {
        google: {},
        map: {},
        markers: [],
        markersStation: [],
        sensorSelected: null,
        isZoneSelected : false,
        updatingZone: false,
        zone: {
          name: null,
        },
      };
    },
    computed: {
      ...mapState('holeList', {
        holes: (state) => state.holes,
        loading: (state) => state.loading,
        rssiRanges: (state) => state.rssiRanges,
        holeSelected: (state) => state.holeSelected,
        zones: (state) => state.zones,
        zoneSelected: (state) => state.zoneSelected,
      }),
       ...mapState('Stations', {
        stations: (state) => state.stations,
      }),
      ...mapState(['course']),
      isCourseType(){
        if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
          || !this.course.facility_type){
            return true;
        }else{
          return false;
        }
      }
    },
    methods: {
      ...mapActions('holeList', ['apiGetHoles', 'apiGetSensorByHole', 'apiGetZones', 'apiGetSensorByZone']),
      ...mapActions('Stations', ['apiGetStations']),
      ...mapMutations('holeList', ['setHoleSelected', 'setZoneSelected', 'setHoles']),

      addZone(){
        this.zone = {
          name: null,
        };
        this.$bvModal.show('md-zone-modal');
      },

      showZoneModal(zone){
        this.zone = {...zone};
        this.zone.name = this.G_getZoneName({zone:zone});
        this.$bvModal.show('md-zone-modal');
      },

      async saveZone(){
        
        this.updatingZone = true;

        if(this.zone && this.zone.hole_id){
          const zoneId = this.zone.hole_id;
          const newName = this.zone.name;
          const provisionPayload = {name: newName};

          await updateHole(provisionPayload, this.zone.hole_id).then((r) => {
            let zones = [...this.holes];
            const zone_index = zones.findIndex(x => x.hole_id == zoneId )
            
            zones[zone_index] = {...zones[zone_index], ...{name: newName} };

            this.setHoles(zones);
            
            this.updatingZone = false;
            this.$bvModal.hide('md-zone-modal');
          }).finally(() => {
            this.updatingZone = false;
          });

        }else{
          const provisionPayload = { hole_number: this.holes.length, course_id: this.$store.state.course.course_id, name: this.zone.name};
          
          await saveHole(provisionPayload).then((r) => {
            let zones = [...this.holes];
            zones.push(r);
            this.setHoles(zones);
            this.updatingZone = false;
            this.$bvModal.hide('md-zone-modal');
          }).finally(() => {
            this.updatingZone = false;
          });

        }
      },

      checkCourseType(){
        if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
        || !this.course.facility_type){
          return true;
        }else{
          return false;
        }
      },

      async selectZone(zone) {
        this.isZoneSelected = true;
        await this.apiGetSensorByZone({course_id: this.course.course_id, zone: zone});
        this.getValidSensors();
        this.sensorMap();
      },
      
      selectSensor(sensor_id) {
        /**
         * Note: If we send the sensor object in the @click function we are experiencing a strange behavior. Some times when we refresh the list and the user clicks on a row the past data of the list is sent to the method as if the table store data on cache, that is why we send the index
         * <b-tr @click="selectSensor(index)">
         */
        const sensor = validSensors.find(x => x.sensor_id == sensor_id);
        if(sensor) {
          const rowSelected = document.querySelector(`[row-sensor="${sensor.sensor_id}"]`);
          const alreadySelected = rowSelected.classList.contains("selected");

          document.querySelectorAll(`[row-sensor]`).forEach(element => {
            element.classList.remove("selected");
          });
          this.markers.forEach((m) => {
            m.infoWindow.close();
          });

          if (! alreadySelected) {
            rowSelected.classList.add("selected");
            const mrk = this.markers.findIndex((m) => {
              if (sensor && m.position.lat() === sensor.latitude && m.position.lng() === sensor.longitude) {
                return true;
              }
              return false;
            });
            if (mrk > -1) {
              this.markers[mrk].infoWindow.open(this.map, this.markers[mrk]);
            }
          }
        }
      },

      showSensorDetails(sensor) {
        /**
         * Note: As this method is called inside a column of the row, here we are not experiencing the same issue as "selectSensor" method
         * that is why here we can send the sensor object instead index.
         */
        this.sensorSelected = sensor;
        this.$bvModal.show('md-sensor-details');
      },

      async loadData() {
        await this.apiGetHoles();
        await this.apiGetStations();
        if(this.checkCourseType()){
          await this.apiGetZones(this.course.course_id);
        }
        this.sensorMap();
      },
      async selectHole(hole) {
        this.isZoneSelected = false;
        await this.apiGetSensorByHole(hole);
        this.getValidSensors();
        this.sensorMap();
      },
      sensorMap() {
        if (validSensors.length > 0) {
          if (this.markers.length) {
            this.markers.forEach((m) => {
              m.setMap(null);
            });
          }
          let center = {
            lat: validSensors[0].lat,
            lng: validSensors[0].lng,
          };
          if (validSensors.length > 1) {
            const features = window.turf.featureCollection(
              validSensors.map((o) => window.turf.point([o.lat, o.lng])),
            );
            const gemetryCenter = window.turf.center(features);
            if (gemetryCenter.geometry && gemetryCenter.geometry.coordinates) {
              center = {
                lat: gemetryCenter.geometry.coordinates[0],
                lng: gemetryCenter.geometry.coordinates[1],
              };
            }
          }
          this.setMap(center, 18);
        } else {
          this.initMap();
        }
      },
      async initMap() {
        this.map = await this.G_initMap({
          mapId: 'holesMap',
          center: {
            lat: 0,
            lng: 0,
          },
          zoom: 2
        });
        this.google = this.consts.Google.MAP;
      },
      
      getRssiIcon(sensor) {
        // eslint-disable-next-line
        return require(`@/assets/img/sensor/${this.G_getRssiIcon(sensor, this.rssiRanges)}`);
      },

      setMap(center, zoom) {
        if (this.map && this.google && this.google.maps) {
          var latlngList = [];
          this.markers = validSensors.map((m) => {
            latlngList.push(new this.google.maps.LatLng(m.lat, m.lng));
            const infoWindow = new this.google.maps.InfoWindow({
              content: `
              <h5 class='d-flex align-items-center '> ${this.G_getSensorName({sensor: m, lbl: true, code: false})} <img src="${this.getRssiIcon(m)}" class='ic-sensor-signal'>  </h5>
              <table>
                <tr>
                  <td class='text-right'>${this.$t('general.status')}: </td>
                  <td class='text-left'>${m.status ? m.status.name : ''}</td>
                </tr>
                <tr>
                  <td class='text-right'>${this.$t('sensors.location')}: </td>
                  <td class='text-left'> ${ this.checkCourseType() ? this.G_getSensorLocation({ sensor: m }) : this.G_getZoneName({ zone: m.hole })} </td>
                </tr>
                <tr>
                  <td class='text-right'>${this.$t('weatherStation.serialNumber')}: </td>
                  <td class='text-left'>${m.serial_number}</td>
                </tr>
                <tr>
                  <td class='text-right'>${this.$t('sensors.imeiMeid')}: </td>
                  <td class='text-left'>${m.imei}</td>
                </tr>
                <tr>
                  <td class='text-right'>${this.$t('sensors.provisionDate')}: </td>
                  <td class='text-left'>${this.G_formatDate({date: m.provision_date, pretty: true})}</td>
                </tr>
              </table>
            `,
            });

            infoWindow.addListener('closeclick', ()=>{
              this.selectSensor(newMark.sensorId);
            });

            const newMark = new this.google.maps.Marker({
              infoWindow,
              sensorId: m.sensor_id,
              position: m,
              icon: m.status_id !== this.consts.SensorStatus.CHECK ? MapBlueFlag : MapRedFlag,
            });
            newMark.setMap(this.map);
            newMark.addListener('click', () => {
              this.selectSensor(newMark.sensorId)
            });
            return newMark;
          });

          this.markersStation = this.stations.map((m) => {
            let dataPosition = {
              lat: m.latitude,
              lng: m.longitude,
            }
            latlngList.push(new this.google.maps.LatLng(dataPosition.lat, dataPosition.lng));
            const infoWindow = new this.google.maps.InfoWindow({
              content: `
              <h5 class='d-flex align-items-center '> ${m.name} </h5>
              <table>
                <tr>
                  <td class='text-right'>${this.$t('weatherStation.stations')}: </td>
                  <td class='text-left'>${m.device_sn}</td>
                </tr>
              </table>`,
            });

            const icon = {
              url: MapStation,
              scaledSize: new google.maps.Size(100, 75),
            }

            const newMark = new this.google.maps.Marker({
              infoWindow,
              stationId: m.station_id,
              position: dataPosition,
              icon,
            });
            newMark.setMap(this.map);
            newMark.addListener('click', () => {
               if(!newMark.open){
                  infoWindow.open(this.map, newMark);
                  newMark.open = true;
                } else {
                  infoWindow.close();
                  newMark.open = false;
                }
            });
            return newMark;
          });

          this.markers = this.markers.concat(this.markersStation);

          var bounds = new this.google.maps.LatLngBounds();
          latlngList.map((n) => {
            bounds.extend(n);
          });
          this.map.setCenter(bounds.getCenter());
          this.map.fitBounds(bounds);
          this.map.setZoom(this.map.getZoom() - 1);
          if (this.map.getZoom() > 18) {
            this.map.setZoom(18);
          }

        } else {
          setTimeout(() => {
            this.setMap(center, zoom);
          }, 10);
        }
      },

      onCloseSensorDetailsModal() {
        this.sensorSelected = null;
      },

      getValidSensors(){
        validSensors = [];
        
        if (!this.isZoneSelected && this.holeSelected.sensors.length > 0 || this.isZoneSelected && this.zoneSelected.sensors.length > 0) {
          let sensorsArray = (!this.isZoneSelected) ? this.holeSelected.sensors : this.zoneSelected.sensors;

          for (var i = 0; i < sensorsArray.length; i++){
            if(sensorsArray[i].latitude != undefined && sensorsArray[i].latitude != null && 
              sensorsArray[i].longitude != undefined && sensorsArray[i].longitude != null && 
              !isNaN(sensorsArray[i].latitude) && !isNaN(sensorsArray[i].longitude)
            ){
              if(this.G_validateLatLong(sensorsArray[i].latitude, sensorsArray[i].longitude)){
                sensorsArray[i].lat = sensorsArray[i].latitude;
                sensorsArray[i].lng = sensorsArray[i].longitude;
                validSensors.push(sensorsArray[i]);
              }
            }
          }
        }
      }

    },
    async mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Holes");
        this.$analytics.logEvent("web_holes");
      }

      this.getValidSensors();
      this.initMap();
      this.$parent.$on('courseChange', (val) => {
        if (val) {
          this.loadData();
        } else {
          this.setHoleSelected({});
          this.setZoneSelected({});
        }
      });
      this.loadData();
    },
  };

</script>